import React from "react";
import * as axios from "axios";
import {Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Button, IconButton, Tooltip} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import "./styles.css"

export default class Vouchers extends React.Component {
  state = {
    orderId: '',
    mentions: '',
    amount: '',
    quantity: '1',
    status: 'Restaurant',
    newVoucher: {},
    vouchers: [],
    loading: false,
    isAdmin: false,
    createDialogOpen: false,
  };

  componentDidMount() {
    const isAdmin = localStorage.getItem('admin') === 'true';
    this.setState({isAdmin})
    this.getVouchers()
  }

  getVouchers = async  () => {
    this.setState({loading: true});
    // const baseUrl = 'http://localhost:8080/';
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/vouchers`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    this.setState({vouchers: response.data.filter(v => {
      if (this.state.isAdmin) {
        return true
      }
      return ["Voucher", "OurFault"].includes(v.status)
      }), loading: false});
  }

  createVoucher = async () => {
    // const baseUrl = 'http://localhost:8080/';
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    this.setState({loading: true})
    const response = await axios.default.post(`${baseUrl}v1/admin/vouchers`, {
      orderId: +this.state.orderId,
      reason: this.state.mentions,
      amount: +this.state.amount,
      status: this.state.status === "Restaurant" ? "Voucher" : this.state.status,
      quantity: +this.state.quantity || 1,
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    await this.getVouchers()
    this.setState({newVoucher: response.data, loading: false, createDialogOpen: false})
  }

  render() {
    const vouchers = this.state.vouchers || [];
    const newVoucher = this.state.newVoucher || {};
    const {isAdmin, createDialogOpen} = this.state;
    return (
      <>
        {!this.state.loading && <div className={'vouchers-container'}>
          <div className="vouchers-header">
            <div style={{fontSize: 30, fontWeight: 800}}>Vouchere</div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon/>}
              onClick={() => this.setState({createDialogOpen: true})}
            >
              Adaugă Voucher
            </Button>
          </div>
          {(newVoucher.code) &&
            <>
              <div style={{marginTop: 20, fontSize: 20, fontWeight: 800}}>Voucher Nou</div>
              <div style={{marginTop: 10, fontSize: 20}}>Cod voucher: {newVoucher.code}</div>
              <div style={{marginTop: 10, fontSize: 20}}>Valoare: {newVoucher.value}</div>
          </>
          }
          <table className="vouchers-table" style={{
            borderSpacing: 0
          }}>
            <thead>
            <tr>
              <th
                style={{width: 100, }}>Id comandă
              </th>
              <th
                style={{width: 200, }}>Data
              </th>
              <th
                style={{width: 300, }}>Restaurant
              </th>
              <th style={{width: 150, }}>Cod Voucher</th>
              {this.state.isAdmin && <th
                style={{width: 60, }}>Cantitate
              </th>}
              <th
                style={{width: 60, }}>Sumă
              </th>
              <th
                style={{width: 50, }}>Folosit
              </th>
              <th
                style={{width: 450, }}>Mentiuni
              </th>
              <th
                style={{width: 120, }}>Vina
              </th>
              <th
                style={{width: 200, }}>Creat de
              </th>
            </tr>
            </thead>
            <tbody>
            {vouchers.map((voucher, i) => {
              return (
                <tr key={voucher.id || i}>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.status === "Livrare" ? "Taxă Livrare" : voucher.status === "Custom" ? "Produs" : voucher.orderId}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.created}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.restaurantName}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.voucherCode}</td>
                  {this.state.isAdmin && <td style={{
                    textAlign: 'center',
                  }}>{voucher.quantity}</td>}
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.amount}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.used ? "Da" : "Nu"}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.mentions}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.status === "Voucher" ? "Restaurant" : voucher.status === "OurFault" ? "Vina noastră" : voucher.status}</td>
                  <td style={{
                    textAlign: 'center',
                  }}>{voucher.createdBy}</td>
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>}

        <Dialog open={createDialogOpen} onClose={() => this.setState({createDialogOpen: false})} fullWidth maxWidth="xs">
          <DialogTitle>Adaugă Voucher</DialogTitle>
          <DialogContent>
            <div className="vouchers-form-row">
              <TextField
                label="Id comandă"
                fullWidth
                margin="dense"
                value={this.state.orderId}
                onChange={(event) => {
                  if (event.target.value.length > 7) {
                    return
                  }
                  this.setState({orderId: event.target.value});
                }}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              {isAdmin && (
                <Tooltip title="sau id restaurant pentru Custom sau Livrare">
                  <IconButton size="small"><InfoOutlinedIcon fontSize="small"/></IconButton>
                </Tooltip>
              )}
            </div>
            <div className="vouchers-form-row">
              <TextField
                label="Motiv"
                fullWidth
                margin="dense"
                value={this.state.mentions}
                onChange={(event) => this.setState({mentions: event.target.value})}
              />
              {isAdmin && (
                <Tooltip title="perioada pentru Livrare sau numele produsului pentru Custom">
                  <IconButton size="small"><InfoOutlinedIcon fontSize="small"/></IconButton>
                </Tooltip>
              )}
            </div>
            {isAdmin && (
              <div className="vouchers-form-row">
                <TextField
                  label="Cantitate"
                  fullWidth
                  margin="dense"
                  value={this.state.quantity}
                  onChange={(event) => this.setState({quantity: event.target.value})}
                />
                <Tooltip title="doar pentru Livrare sau Custom">
                  <IconButton size="small"><InfoOutlinedIcon fontSize="small"/></IconButton>
                </Tooltip>
              </div>
            )}
            <div className="vouchers-form-row">
              <TextField
                label="Suma"
                fullWidth
                margin="dense"
                value={this.state.amount}
                onChange={(event) => this.setState({amount: event.target.value})}
              />
              {isAdmin && (
                <Tooltip title="per bucată">
                  <IconButton size="small"><InfoOutlinedIcon fontSize="small"/></IconButton>
                </Tooltip>
              )}
            </div>
            <div className="vouchers-form-row">
              <TextField
                select
                label={isAdmin ? "Tip" : "Vină"}
                fullWidth
                margin="dense"
                value={this.state.status}
                onChange={(event) => this.setState({status: event.target.value})}
              >
                <MenuItem value={'Voucher'}>Restaurant</MenuItem>
                <MenuItem value={'OurFault'}>A noastră</MenuItem>
                {isAdmin && [
                  <MenuItem key="livrare" value={'Livrare'}>Livrare</MenuItem>,
                  <MenuItem key="custom" value={'Custom'}>Custom</MenuItem>,
                ]}
              </TextField>
              {isAdmin && (
                <Tooltip title='Restaurant și "A noastră" creează voucher'>
                  <IconButton size="small"><InfoOutlinedIcon fontSize="small"/></IconButton>
                </Tooltip>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({createDialogOpen: false})}>
              Anulează
            </Button>
            <Button
              onClick={this.createVoucher}
              color="primary"
              variant="contained"
            >
              {isAdmin ? "Crează" : "Crează voucher"}
            </Button>
          </DialogActions>
        </Dialog>

        {this.state.loading &&
          <div className={'loader-container'}>
            <div className={'loader'}/>
          </div>}
      </>
    )
  }
}